import { render, staticRenderFns } from "./templateChart.vue?vue&type=template&id=96b13bb0&scoped=true"
import script from "./templateChart.vue?vue&type=script&lang=js"
export * from "./templateChart.vue?vue&type=script&lang=js"
import style0 from "./templateChart.vue?vue&type=style&index=0&id=96b13bb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b13bb0",
  null
  
)

export default component.exports